module.exports = __webpack_public_path__ + "media/ask/male-front-0449d82b.svg";